import axios from "axios";
import API from "../helpers/api";
import FileSaver from "file-saver";
import { toast } from "react-toastify";
import {
  getIHMFullManual,
  getRevisionHistory,
  getOtherTask,
} from "../Actions/ShipViewAPI";
import {getLRFormUpdate,
} from "../Actions/ShipManagementAPI";
import { getPOLineItems, getPOLineItem, } from "../Actions/POViewAPI";
import { hideLoader, showLoader } from "./PageLoaderAPI";

let userkey = JSON.parse(localStorage.getItem("currentUser"));

export const UploadDocument = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "AttachmentUploadSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "AttachmentUploadFailure",
          error: "ERROR",
        });
      });
  };
};
export const UploadLRDocument = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "AttachmentLRUploadSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "AttachmentLRUploadFailure",
          error: "ERROR",
        });
      });
  };
};

export const UploadInventoryDocument = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        if (response.data) {
          toast.success("Inventory Data Uploaded Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        dispatch({
          type: "InventoryUploadSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "InventoryUploadFailure",
          error: "ERROR",
        });
      });
  };
};

export const UploadInventory = (postItem) => {
  let url = `${API.InventoryDocument}`;
  return (dispatch) => {
    axios
      .post(url, postItem)
      .then((response) => {
        dispatch({
          type: "UploadInventorySuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "UploadInventoryFailure",
          error: "ERROR",
        });
      });
  };
};

export const UploadDocuments = (files, shipId) => {
  const data = new FormData();
  for (const postItem of files) {
    data.append("file", postItem);
  }

  let url = `${API.AttachmentsAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        if (response.data) {
          let url = `${API.PostDocumentAPI}`;
          let url1 = response.data.map((i) => ({
            shipId: shipId,
            isDeleted: false,
            isPdf: false,
            attachmentId: 0,
            attachmentName: i.FileName,
            attachmentGuid: i.Guid,
          }));
          axios
            .put(url, url1, {
              headers: {
                key: userkey.accessToken,
              },
            })
            .then((res) => {
              dispatch(getAttachments(shipId));
              dispatch({
                type: "PostDocumentSuccess",
                data: res.data,
              });
            })
            .catch((error) => {
              dispatch({
                type: "PostDocumentFailure",
                data: "error",
              });
            });
        }
        dispatch({
          type: "AttachmentsUploadSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "AttachmentsUploadFailure",
          error: "ERROR",
        });
      });
  };
};

export const UploadDocumentsPDF = (files, shipId) => {
  const data = new FormData();
  for (const postItem of files) {
    data.append("file", postItem);
  }

  let url = `${API.AttachmentsAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        if (response.data) {
          let url = `${API.PostDocumentAPI}`;
          let url1 = response.data.map((i) => ({
            shipId: shipId,
            isDeleted: false,
            isPdf: true,
            attachmentId: 0,
            attachmentName: i.FileName,
            attachmentGuid: i.Guid,
          }));
          axios
            .put(url, url1, {
              headers: {
                key: userkey.accessToken,
              },
            })
            .then((res) => {
              dispatch(getAttachmentsPDF(shipId));
              dispatch({
                type: "PostDocumentSuccess",
                data: res.data,
              });
            })
            .catch((error) => {
              dispatch({
                type: "PostDocumentFailure",
                data: "error",
              });
            });
        }
        dispatch({
          type: "AttachmentsUploadSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "AttachmentsUploadFailure",
          error: "ERROR",
        });
      });
  };
};

export const deleteImages = (data, id) => {
  let url = `${API.PostDocumentAPI}`;
  return (dispatch) => {
    axios
      .put(url, data, {
        headers: {
          key: userkey.accessToken,
        },
      })
      .then((response) => {
        dispatch(getAttachments(id));
        if (response.data) {
          toast.success("Deleted Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        dispatch({
          type: "DeleteImgSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "DeleteImgFailure",
          error: "ERROR",
        });
      });
  };
};

export const getAttachments = (shipId) => {
  let url = `${API.getDocumentAPI}?ShipId=${shipId}&isPdf=${false}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        if (response.data) {
          let url2 = response.data.map((i) => ({
            src: "data:image/png;base64," + i.attachment,
            tiltle: "",
            description: i.attachmentName,
            id: i.attachmentId,
          }));
          dispatch(getAttachmentsPDF(shipId));
          dispatch({
            type: "getAttachmentsSuccess",
            data: url2,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: "getAttachmentsFailure",
          error: "ERROR",
        });
      });
  };
};

export const getAttachmentsPDF = (shipId) => {
  let url = `${API.getDocumentAPI}?ShipId=${shipId}&isPdf=${true}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        if (response.data) {
          let url2 = response.data.map((i) => ({
            attachmentName: i.attachmentName,
            attachmentGuid: i.attachmentGuid,
            attachmentId: i.attachmentId,
            fileUrl:i.fileUrl
          }));
          dispatch({
            type: "getAttachmentsPDFSuccess",
            data: url2,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: "getAttachmentsPDFFailure",
          error: "ERROR",
        });
      });
  };
};

export const UploadMDoc = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "AttachmentUploadMDocSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "AttachmentUploadMDocFailure",
          error: "ERROR",
        });
      });
  };
};
export const UploadSDoc = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "AttachmentUploadSDocSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "AttachmentUploadSDocFailure",
          error: "ERROR",
        });
      });
  };
};
export const UploadHKC = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        if (response.data) {
          toast.success("HKC Uploaded Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        dispatch({
          type: "AttachmentUploadHKCSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "AttachmentUploadHKCFailure",
          error: "ERROR",
        });
      });
  };
};
export const UploadEUSSR = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        if (response.data) {
          toast.success("EUSSR Uploaded Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        dispatch({
          type: "AttachmentUploadEUSSRSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "AttachmentUploadEUSSRFailure",
          error: "ERROR",
        });
      });
  };
};
export const UploadFullManual = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        if (response.data) {
          toast.success("IHM Full Manual Uploaded Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        dispatch({
          type: "AttachmentUploadFullManualSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "AttachmentUploadFullManualFailure",
          error: "ERROR",
        });
      });
  };
};

export const UploadFlagSoc = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        if (response.data) {
          toast.success("Flag SOC Uploaded Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        dispatch({
          type: "AttachmentUploadFlagSOCSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "AttachmentUploadFlagSOCFailure",
          error: "ERROR",
        });
      });
  };
};

export const UploadIAPP = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        if (response.data) {
          toast.success("IAPP Uploaded Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        dispatch({
          type: "AttachmentUploadIAPPSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "AttachmentUploadIAPPFailure",
          error: "ERROR",
        });
      });
  };
};

export const Uploadec = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        if (response.data) {
          toast.success("Exemption Certificate Uploaded Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        dispatch({
          type: "AttachmentUploadecSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "AttachmentUploadecFailure",
          error: "ERROR",
        });
      });
  };
};

export const Uploadldafd = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        if (response.data) {
          toast.success(
            "Last Drydock Asbestos Free Declaration Uploaded Successfully",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            }
          );
        }
        dispatch({
          type: "AttachmentUploadldafdSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "AttachmentUploadldafdFailure",
          error: "ERROR",
        });
      });
  };
};

export const Uploadamp = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        if (response.data) {
          toast.success("Asbestos Management Plan Uploaded Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        dispatch({
          type: "AttachmentUploadampSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "AttachmentUploadampFailure",
          error: "ERROR",
        });
      });
  };
};

export const DownloadDocument = (filename, guid) => {
  let url = `${API.DownloadAttachmentAPI}?filename=${btoa(
    filename
  )}&guidValue=${guid}`;
  return (dispatch) => {
    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        let blob = "";
        blob = new Blob([response.data], { type: response.data.type });
        FileSaver.saveAs(blob, filename);
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "AttchmentDownloadFailure",
          error: "ERROR",
        });
      });
  };
};

export const deleteMDocument = (item, poid,type) => {
  let url = `${API.DeleteAttachmentAPI}`;
  return (dispatch) => {
    let data = {
      mdocattachmentId: item.mdocAttachmentId,
      poLineItemId: item.poLineItemId,
      purchaseOrderId: item.purchaseOrderId,
      isDeleted: true,
    };
    axios
      .put(url, data)
      .then((response) => {
        if (response.data) {
          toast.success("Deleted Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          if(type===undefined){
            dispatch(getPOLineItem(poid));
          }else{
            dispatch(getPOLineItems(poid, type));
          }
         
        }
        dispatch({
          type: "DeleteMDocumentSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "DeleteMDocumentFailure",
          error: "ERROR",
        });
      });
  };
};

export const deleteSDocument = (item, poid,type) => {
  let url = `${API.DeleteAttachmentAPI}`;
  return (dispatch) => {
    let data = {
      sdocattachmentId: item.sdocAttachmentId,
      poLineItemId: item.poLineItemId,
      purchaseOrderId: item.purchaseOrderId,
      isDeleted: true,
    };
    axios
      .put(url, data)
      .then((response) => {
        if (response.data) {
          toast.success("Deleted Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          if(type===undefined){
            dispatch(getPOLineItem(poid));
          }else{
          dispatch(getPOLineItems(poid, type));
          }
        }
        dispatch({
          type: "DeleteSDocumentSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "DeleteSDocumentFailure",
          error: "ERROR",
        });
      });
  };
};

export const DeleteMDocSdocAttachments = (poid,tasktype) => {
  let url = `${API.DeleteMDocSdocAttachments}`;
  return (dispatch) => {
    let data = {
      purchaseOrderId: poid,
      isDeleted: true,
      deleteAll: true,
    };
    axios
      .put(url, data)
      .then((response) => {
        if (response.data) {
          toast.success("Deleted Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          if(tasktype===undefined){
            dispatch(getPOLineItem(poid));
          }else{
          dispatch(getPOLineItems(poid, tasktype));
          }
        }
        dispatch({
          type: "DeleteMDocSDocSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "DeleteMDocSDOcFailure",
          error: "ERROR",
        });
      });
  };
};

export const UploadRevisionDocument = (postItem, clearData, id, shipId) => {
  let url = `${API.UploadRevision}?AttachmentName=${postItem.attachmentName}&AttachmentGuid=${postItem.attachmentGuid}&shipId=${postItem.shipId}`;
  return (dispatch) => {
    axios
      .post(url)
      .then((response) => {
        dispatch(getRevisionHistory(id));
        dispatch(getIHMFullManual(shipId));
        dispatch({
          type: "UploadSuccessfull",
          data: response.data,
        });
        // if (response.data) {
        // toast.success('Uploaded Successfully', {
        //     position: "top-right",
        //     autoClose: 5000,
        //     hideProgressBar: true,
        //     closeOnClick: true,
        //     pauseOnHover: true,
        //     draggable: true,
        //     progress: undefined,
        // });
        // }
        dispatch({
          type: "AttachmentUploadSuccess",
          data: clearData,
        });
      })
      .catch((error) => {
        dispatch({
          type: "UploadFailure",
          error: "ERROR",
        });
      });
  };
};
export const UploadLRFROMDocument = (postItem, clearData,currentuser,id) => {
  let url = `${API.UploadLRFrom}?AttachmentName=${postItem.attachmentName}&AttachmentGuid=${postItem.attachmentGuid}&shipId=${postItem.shipId}&createdBy=${currentuser}`;
  return (dispatch) => {
    axios
      .put(url)
      .then((response) => {
        dispatch(getLRFormUpdate(id, true));
        dispatch({
          type: "UploadSuccessfull",
          data: response.data,
        });
        dispatch({
          type: "AttachmentLRUploadSuccess",
          data: clearData,
        });
      })
      .catch((error) => {
        dispatch({
          type: "UploadFailure",
          error: "ERROR",
        });
      });
  };
};

export const UploadShipDocument = (postItem, clearData) => {
  let url = `${API.ShipDocument}`;
  return (dispatch) => {
    axios
      .post(url, postItem)
      .then((response) => {
        dispatch(getShipDocuments(postItem.shipId));
        dispatch({
          type: "UploadShipDocumentSuccess",
          data: response.data,
        });
        if (response.data) {
          toast.success("Added Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        dispatch({
          type: "AttachmentUploadSuccess",
          data: clearData,
        });
      })
      .catch((error) => {
        dispatch({
          type: "UploadShipDocumentFailure",
          error: "ERROR",
        });
      });
  };
};

export const getShipDocuments = (shipId) => {
  let url = `${API.GetShipDocument}?shipId=${shipId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getShipDocumentSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getShipDocumentFailure",
          error: "ERROR",
        });
      });
  };
};

export const DeleteShipDocuments = (data, shipId) => {
  let url = `${API.ShipDocument}`;
  return (dispatch) => {
    axios
      .put(url, data)
      .then((response) => {
        if (response.data) {
          toast.success("Deleted Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          dispatch(getShipDocuments(shipId));
        }
        dispatch({
          type: "deleteShipDocumentSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "deleteShipDocumentFailure",
          error: "ERROR",
        });
      });
  };
};

export const getTEFormsDocuments = (shipId) => {
  let url = `${API.GetTEForms}?shipId=${shipId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getTEFormsSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getTEFormsFailure",
          error: "ERROR",
        });
      });
  };
};

export const UploadTEForms = (postItem, clearData) => {
  let url = `${API.GetTEForms}`;
  return (dispatch) => {
    axios
      .post(url, postItem)
      .then((response) => {
        dispatch(getTEFormsDocuments(postItem.shipId));
        dispatch({
          type: "UploadTEFormsuccess",
          data: response.data,
        });
        if (response.data) {
          toast.success("Added Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        dispatch({
          type: "AttachmentUploadSuccess",
          data: clearData,
        });
      })
      .catch((error) => {
        dispatch({
          type: "UploadTEFormsFailure",
          error: "ERROR",
        });
      });
  };
};

export const DeleteTEForms = (data, shipId) => {
  let url = `${API.GetTEForms}`;
  return (dispatch) => {
    axios
      .put(url, data)
      .then((response) => {
        if (response.data) {
          toast.success("Deleted Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          dispatch(getTEFormsDocuments(shipId));
        }
        dispatch({
          type: "deleteTEFormsuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "deleteTEFormsFailure",
          error: "ERROR",
        });
      });
  };
};

export const UploadMultipleDocuments = (files, shipId, searchData) => {
  const data = new FormData();
  for (const postItem of files) {
    data.append("file", postItem);
  }

  let url = `${API.AttachmentsAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        if (response.data) {
          let datas = response.data.map((i) => ({
            isDeleted: false,
            attachmentId: 0,
            attachmentName: i.FileName,
            attachmentGuid: i.Guid,
          }));
          let tasks = {
            shipId: shipId,
            task: searchData.taskType,
            description: searchData.taskdescription,
            deadLine: searchData.taskdeadLine,
            attachments: datas,
            createdBy: userkey.email,
          };
          dispatch({ type: "GetOtherTaskList", data: tasks });
        }
        dispatch({
          type: "AttachmentsUploadSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "AttachmentsUploadFailure",
          error: "ERROR",
        });
      });
  };
};

export const deleteMultipleImages = (data, id) => {
  let url = `${API.PutOtherTask}`;
  return (dispatch) => {
    axios
      .put(url, data, {
        headers: {
          key: userkey.accessToken,
        },
      })
      .then((response) => {
        dispatch(getOtherTask(id, 1));
        if (response.data) {
          toast.success("Deleted Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        dispatch({
          type: "DeleteMultipleImgSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "DeleteMultipleImgFailure",
          error: "ERROR",
        });
      });
  };
};

export const getClassFlagCirculars = () => {
  let url = `${API.GetClassFlagCirculars}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getClassFlagCircularsSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getClassFlagCircularsFailure",
          error: "ERROR",
        });
      });
  };
};

export const getTeamsList = (email) => {
  let url = `${API.GetTeamsOfUser}?mail=` + email;

  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        if (response && response.data) {
          dispatch(GetKPIData(response.data.teams[0].userId));
        }
        dispatch({
          type: "getTeamsListsSuccess",
          data: response.data,
        });
        dispatch({
          type: "SetTeamsUserIdSuccess",
          data: response.data.teams[0].userId,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getTeamsListsFailure",
          error: "ERROR",
        });
      });
  };
};

export const GetKPIData = (userId) => {
  let url = `${API.GetKPIData}`;

  if (userId) {
    url =
      url +
      `?userId=${userId}&today=true&last7Days=false&last14Days=false&last1Month=false&last6Month=false`;
  }
  return (dispatch) => {
    dispatch(showLoader());
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getKPIDashboardDataSuccess",
          data: response.data,
        });
        dispatch(hideLoader());
      })
      .catch((error) => {
        dispatch({
          type: "getKPIDashboardDataFailure",
          error: error,
        });
        dispatch(hideLoader());
      });
  };
};

export const getUsersList = () => {
  let url = `${API.GetAllUsersData}`;

  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getUsersListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getUsersListFailure",
          error: error,
        });
      });
  };
};

export const getTeamForUser = (userid) => {
  let url = `${API.GetUserTeams}?userId=` + userid;

  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getTeamsSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getTeamsFailure",
          error: error,
        });
      });
  };
};
